import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./StudentCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import SessionFormation from "./SessionFormation";
import TeacherInformation from "./TeacherInformation";
import GroupInformation from "./GroupInformation";


// Services
import { createSessionFormation } from "../../services/sessions.service";
import { showSuccess, showError } from "../../services/toast.service";

const SessionsFormationCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sessionData, setSessionData] = useState({
    title: '',
    start_date: '',
    end_date: '',
    session_type: 'Présentiel',
    room: '',
    room_link: '',
    teacher_id: null,
    session_id: null, // Relation vers session_groups
    status: 'Ouvert'
  });

  const handleInputChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  // Validation des champs requis
  const validateForm = () => {
    const errors = [];
    
    if (!sessionData.title?.trim()) {
      errors.push('Le titre de la session est requis');
    }
    
    if (!sessionData.start_date) {
      errors.push('La date de début est requise');
    }
    
    if (!sessionData.end_date) {
      errors.push('La date de fin est requise');
    }
        
    if (!sessionData.teacher_id) {
      errors.push('Un professeur doit être sélectionné');
    }
    
    if (!sessionData.session_id) {
      errors.push('Un groupe de session doit être sélectionné');
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation avant soumission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      const errorMessage = 'Veuillez corriger les erreurs suivantes:\n' + validationErrors.join('\n');
      showError(errorMessage);
      setError(errorMessage);
      setLoading(false);
      return;
    }

    try {
      console.log('Données de session à envoyer:', sessionData);
      await createSessionFormation(sessionData);
      showSuccess("Session formation créée avec succès!");
      navigate("/admin/sessions-formation/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer la session formation: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Vérifier si le formulaire est valide pour activer/désactiver le bouton
  const isFormValid = () => {
    return validateForm().length === 0;
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/sessions-formation/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <SessionFormation
              sessionData={sessionData}
              onInputChange={handleInputChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <TeacherInformation
              sessionData={sessionData}
              onInputChange={handleInputChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <GroupInformation
              sessionData={sessionData}
              onInputChange={handleInputChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
              loading={loading}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default SessionsFormationCreate;
